import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexModule} from "@angular/flex-layout";
import {MatButtonModule} from "@angular/material/button";
import {MatCardModule} from "@angular/material/card";
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule, MatMenuTrigger} from "@angular/material/menu";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatTabsModule} from "@angular/material/tabs";
import {PipesModule} from "../../theme/pipes/pipes.module";
import {NotificationBellService} from "./notification-bell.service";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {NotificationService} from "./notification.service";
import {CustomDateUtils} from "../../utils/CustomDateUtils";
import {FormsModule} from "@angular/forms";
import {UserStorageService} from "../../services/UserStorageService";

@Component({
    selector: 'app-notification-bell',
    imports: [CommonModule, FlexModule, MatButtonModule, MatCardModule, MatIconModule, MatMenuModule, MatProgressBarModule, MatTabsModule, PipesModule, TranslateModule, FormsModule],
    providers: [NotificationBellService, NotificationService],
    templateUrl: './notification-bell.component.html',
    styleUrls: ['./notification-bell.component.scss']
})
export class NotificationBellComponent implements OnInit {

  @Input() isOpen = false; // Input to control visibility
  @Output() closeSidebar = new EventEmitter<void>(); // Output to notify parent

  @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
  public selectedTab:number=1;
  public messages:Array<Object>;
  public files:Array<Object>;
  public meetings:Array<Object>;
  constructor(public messagesService:NotificationBellService, public translate: TranslateService, private notificationService: NotificationService,
              private userStorage: UserStorageService) {
    this.notificationService.connect();
    // connect() is a no-op without a token, so open the socket after login too.
    this.userStorage.loggedIn$.subscribe(() => this.notificationService.connect());
  }


  close() {
    this.isOpen = false;
  }

  ngOnInit() {

  }
  searchQuery = '';

  filteredNotifications(all: any[]): any[] {
    let list = all;
    if (this.selectedTab === 1) list = list.filter(n => !n.is_read);
    if (this.selectedTab === 2) list = list.filter(n => n.flag);
    if (this.searchQuery.trim()) {
      const q = this.searchQuery.toLowerCase();
      list = list.filter(n =>
          n.subject?.toLowerCase().includes(q) ||
          n.message?.toLowerCase().includes(q)
      );
    }
    return list;
  }

  todayGroup(list: any[]): any[] {
    const today = new Date().toDateString();
    return list.filter(n => new Date(n.timestamp).toDateString() === today);
  }

  earlierGroup(list: any[]): any[] {
    const today = new Date().toDateString();
    return list.filter(n => new Date(n.timestamp).toDateString() !== today);
  }

  markAllRead() {
    // call your service bulk-read endpoint
  }

  toggleSidebar() {
    this.isOpen = !this.isOpen;
  }

  openMessagesMenu() {
    this.trigger.openMenu();
    this.selectedTab = 0;
  }

  onMouseLeave(){
    this.trigger.closeMenu();
  }

  toggleFlag(notification: any, event: Event) {
    event.stopPropagation();
    this.messagesService.raiseFlag(notification.id)
        .subscribe((res) => {
          if(res.success){
            notification.flag = res.flag;  // toggle flag
          }
        });
  }
  markAsRead(notification: any) {
    this.messagesService.handle(notification.data);
    this.close();
    if(!notification.is_read){
      this.messagesService.markAsRead(notification.id).subscribe(res=>{
        if (!notification.is_read) {
          notification.is_read = true;
        }
      },error => {

      })
    }
  }
  stopClickPropagate(event: any){
    event.stopPropagation();
    event.preventDefault();
  }

  protected readonly CustomDateUtils = CustomDateUtils;
}
